/* PDRINOX – Tamamlayıcı ürünler (add-on) alanı */
if (!customElements.get('pdr-addons')) {
  class PdrAddons extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.statusEl = this.querySelector('[data-pdr-status]');
      this.allBtn = this.querySelector('[data-pdr-all]');
      this.allLabel = this.allBtn ? this.allBtn.textContent : '';

      this.items().forEach((item) => {
        const btn = item.querySelector('[data-pdr-add]');
        const select = item.querySelector('[data-pdr-variant]');
        if (select) select.addEventListener('change', () => this.onVariantChange(item, select));
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-added') || btn.getAttribute('aria-busy') === 'true') return;
          this.add([item]);
        });
      });

      if (this.allBtn) {
        this.allBtn.addEventListener('click', () => {
          if (this.allBtn.getAttribute('aria-busy') === 'true') return;
          const pending = this.items().filter((i) => !i.querySelector('[data-pdr-add]').classList.contains('is-added'));
          if (pending.length) this.add(pending, this.allBtn);
        });
      }

      this.watchCart();
      this.syncWithCart();
    }

    disconnectedCallback() {
      if (this._unsubscribe) this._unsubscribe();
      if (this._observer) this._observer.disconnect();
      if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
    }

    watchCart() {
      const queueSync = () => {
        clearTimeout(this._syncTimer);
        this._syncTimer = setTimeout(() => this.syncWithCart(), 350);
      };
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, queueSync);
        }
      } catch (e) {}
      const targets = ['cart-icon-bubble', 'cart-icon-quick']
        .map((id) => document.getElementById(id))
        .filter(Boolean);
      if (targets.length && 'MutationObserver' in window) {
        this._observer = new MutationObserver(queueSync);
        targets.forEach((t) => this._observer.observe(t, { childList: true, subtree: true, characterData: true }));
      }
      this._onPageShow = queueSync;
      window.addEventListener('pageshow', this._onPageShow);
      window.addEventListener('focus', queueSync);

      PdrAddons.hookCartRequests(queueSync);
    }

    static hookCartRequests(callback) {
      if (!window.__pdrCartListeners) {
        window.__pdrCartListeners = new Set();
        const isCartWrite = (url) => /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || ''));
        const notify = () => window.__pdrCartListeners.forEach((fn) => { try { fn(); } catch (e) {} });

        if (window.fetch) {
          const originalFetch = window.fetch;
          window.fetch = function (input) {
            const promise = originalFetch.apply(this, arguments);
            try {
              const url = typeof input === 'string' ? input : input && input.url;
              if (isCartWrite(url)) promise.then(notify, notify);
            } catch (e) {}
            return promise;
          };
        }

        if (window.XMLHttpRequest) {
          const originalOpen = XMLHttpRequest.prototype.open;
          const originalSend = XMLHttpRequest.prototype.send;
          XMLHttpRequest.prototype.open = function (method, url) {
            this.__pdrUrl = url;
            return originalOpen.apply(this, arguments);
          };
          XMLHttpRequest.prototype.send = function () {
            if (isCartWrite(this.__pdrUrl)) this.addEventListener('loadend', notify);
            return originalSend.apply(this, arguments);
          };
        }
      }
      window.__pdrCartListeners.add(callback);
    }

    async syncWithCart() {
      try {
        const cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
        const res = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        const inCart = new Set((cart.items || []).map((line) => line.variant_id));
        let removed = false;
        this.items().forEach((item) => {
          const btn = item.querySelector('[data-pdr-add]');
          if (btn.getAttribute('aria-busy') === 'true') return;
          const has = inCart.has(this.variantId(item));
          if (has && !btn.classList.contains('is-added')) {
            btn.classList.add('is-added');
            btn.textContent = '\u2713 ' + this.dataset.addedLabel;
          } else if (!has && btn.classList.contains('is-added')) {
            btn.classList.remove('is-added');
            btn.textContent = this.dataset.addLabel;
            removed = true;
          }
        });
        this.updateAllButton();
        if (removed && this.statusEl && !this.statusEl.classList.contains('is-error')) this.setStatus('');
      } catch (e) {}
    }

    items() {
      return Array.from(this.querySelectorAll('[data-pdr-item]'));
    }

    variantId(item) {
      const select = item.querySelector('[data-pdr-variant]');
      return Number(select ? select.value : item.querySelector('[data-pdr-add]').dataset.variantId);
    }

    onVariantChange(item, select) {
      const opt = select.selectedOptions[0];
      const price = item.querySelector('[data-pdr-price]');
      const compare = item.querySelector('[data-pdr-compare]');
      if (price) price.textContent = opt.dataset.price;
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      const btn = item.querySelector('[data-pdr-add]');
      btn.classList.remove('is-added');
      btn.textContent = this.dataset.addLabel;
      this.updateAllButton();
      this.syncWithCart();
    }

    getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    async add(items, trigger) {
      const buttons = items.map((i) => i.querySelector('[data-pdr-add]'));
      const busy = trigger ? buttons.concat(trigger) : buttons;
      busy.forEach((b) => b.setAttribute('aria-busy', 'true'));
      this.setStatus('');

      const cart = this.getCart();
      const sections = ['cart-icon-bubble'];
      if (cart && typeof cart.getSectionsToRender === 'function') {
        cart.getSectionsToRender().forEach((s) => {
          if (!sections.includes(s.id)) sections.push(s.id);
        });
      }

      const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: items.map((i) => ({ id: this.variantId(i), quantity: 1, properties: { _source: 'complementary' } })),
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');

        buttons.forEach((b) => {
          b.classList.add('is-added');
          b.textContent = '\u2713 ' + this.dataset.addedLabel;
        });
        this.updateAllButton();
        this.setStatus('\u2713 ' + this.dataset.successLabel);
        this.refreshCart(cart, data);
      } catch (e) {
        this.setStatus(e.message, true);
      } finally {
        busy.forEach((b) => b.removeAttribute('aria-busy'));
      }
    }

    refreshCart(cart, data) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdr-addons', cartData: data });
        }
      } catch (e) {}

      const cartType = document.body.dataset.cartType;
      try {
        if (cart && data.sections && cart.tagName === 'CART-NOTIFICATION') {
          const last = data.items && data.items[data.items.length - 1];
          if (last) data.key = last.key;
          cart.renderContents(data);
          return;
        }
        if (cart && data.sections) {
          const open = cartType !== 'sticky_cart_bar' && this.dataset.openDrawer === 'true';
          cart.renderContents(data, open);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (cartType === 'sticky_cart_bar') {
            const notify = document.querySelector('.quick-notify');
            if (notify) notify.classList.add('active');
          }
          return;
        }
      } catch (e) {
        console.error(e);
      }

      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections && data.sections['cart-icon-bubble'];
      if (bubble && html) {
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    }

    updateAllButton() {
      if (!this.allBtn) return;
      const allAdded = this.items().every((i) => i.querySelector('[data-pdr-add]').classList.contains('is-added'));
      this.allBtn.classList.toggle('is-added', allAdded);
      this.allBtn.textContent = allAdded ? '\u2713 ' + this.dataset.addedLabel : this.allLabel;
    }

    setStatus(text, isError) {
      if (!this.statusEl) return;
      this.statusEl.textContent = text || '';
      this.statusEl.classList.toggle('is-error', !!isError);
    }
  }
  customElements.define('pdr-addons', PdrAddons);
}
